import { BrowserRouter } from "react-router";
import { AppRouter } from "./routes/AppRouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ToastContainer } from "react-toastify";

function App() {

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ToastContainer />
        <AppRouter />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
